
import { get_cart_product_count } from "@/api/cart";

const state = {
  cartProductCount: 0
}
const mutations = {
  SET_CART_PRODUCT_COUNT (state, value) {
    state.cartProductCount = Number(value)
  }
}
const actions = {
  setCartProductCount ({ commit }, value) {
    commit('SET_CART_PRODUCT_COUNT', value)
  },
  // 更新购物车数量
  updateCartProductCount ({ commit }) {
    get_cart_product_count()
      .then(res => {
        commit('SET_CART_PRODUCT_COUNT', res)
        // console.log(res)
      })
      .catch(() => { })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
